import React, {PureComponent} from 'react';
import conf from 'common/js/conf';


/**
 * 下载App按钮
 */
export default class DownloadApp extends PureComponent {
    render() {
        return(
            <a href={conf.links.downLoad} title="下载虎牙APP" {...this.props}>
                {this.props.children}
            </a>
        )
    }
}


// WEBPACK FOOTER //
// ./src/common/components/button/DownloadApp.jsx